
import { Options, Vue } from "vue-class-component";
import store from "@/store";

@Options({})
export default class App extends Vue {
  async mounted() {
    console.log(this.$route.path);
    if (
      this.$route.path == "/" ||
      this.$route.path == "/commerce" ||
      this.$route.path == "/privacypolicy" ||
      this.$route.path == "/termsofuse" ||
      this.$route.path == "/login"
    ) {
      return;
    }
    store.dispatch("refreshUser");
  }
}
